import {Pipe, PipeTransform} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Pipe({
  name: 'secureImg'
})
export class SecureImgPipe implements PipeTransform {

  constructor(private http: HttpClient) {
  }

  transform(url: string) {

    return new Observable<string>((observer) => {
      // This is a tiny blank image
      observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

      // The next and error callbacks from the observer
      const {next, error} = observer;

      this.http.get(url, {responseType: 'blob'}).subscribe(response => {
        const reader = new FileReader();
        reader.readAsDataURL(response);
        reader.onloadend = () => {
          observer.next(typeof reader.result == 'string' ? reader.result : undefined);
        };
      });

      return {
        unsubscribe() {
        }
      };
    });
  }

}
